import { render, staticRenderFns } from "./ns-new-password.vue?vue&type=template&id=4221f94b&"
import script from "./ns-new-password.vue?vue&type=script&lang=js&"
export * from "./ns-new-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports